type SignalButtonTooltipOptions = {
    nextPressIsFree: boolean
    upvaluesEnabled: boolean
    freeReactionAvailable: boolean
    seed: boolean
    alreadySeeded: boolean
    ownPost: boolean
    showBoost: boolean
}

export function quickSignalPressIsFree(nextPressIsFree: boolean, seed: boolean): boolean {
    return nextPressIsFree && !seed
}

export function signalButtonTooltip({
    nextPressIsFree,
    upvaluesEnabled,
    freeReactionAvailable,
    seed,
    alreadySeeded,
    ownPost,
    showBoost,
}: SignalButtonTooltipOptions): string {
    if (nextPressIsFree || (!upvaluesEnabled && freeReactionAvailable)) {
        return 'React for free.'
    }
    if (seed && ownPost) {
        return 'Seeding your own post rewards Treechat and prior Seeders.'
    }
    if (seed && alreadySeeded) {
        return 'You seeded this post. Seed again to grow your stake.'
    }
    if (seed) return 'Seed this post.'
    if (showBoost) return 'Boost this post.'
    return 'Upvalue this post.'
}
